import { Routes, Route } from 'react-router-dom'
import { MainLayout } from './layouts/MainLayout'
import { Agents } from './pages/Agents'
import { Config } from './pages/Config'
import { History } from './pages/History'
import { Overview } from './pages/Overview'
import { Preferences } from './pages/Preferences'
import { Experience } from './pages/Experience'
import { Integrations } from './pages/Integrations'
import { Account } from './pages/Account'

export const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Overview />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/config" element={<Config />} />
        <Route path="/history" element={<History />} />
        <Route path="/preferences" element={<Preferences />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/account" element={<Account />} />
      </Route>
    </Routes>
  )
} 